var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 71,
    viewBox: "0 0 97 71",
    fill: "#5a94d3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.8125 27.9297H81.2109V15.7266C81.2109 13.8252 79.6748 12.2891 77.7734 12.2891H43.9355L31.335 0.236328C31.1746 0.0862356 30.9638 0.00188307 30.7441 0H3.4375C1.53613 0 0 1.53613 0 3.4375V67.0312C0 68.9326 1.53613 70.4688 3.4375 70.4688H78.418C79.8145 70.4688 81.082 69.6201 81.6084 68.3203L96.0029 32.6562C96.1641 32.248 96.25 31.8076 96.25 31.3672C96.25 29.4658 94.7139 27.9297 92.8125 27.9297ZM73.4766 27.9297H18.6914C17.2949 27.9297 16.0273 28.7783 15.501 30.0781L7.73438 49.3281V7.73438H27.9834L40.8311 20.0234H73.4766V27.9297Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.fe6eb8de73c785b1b5d8652aa9eb402a.svg";
export { ForwardRef as ReactComponent };